/* eslint-disable consistent-return */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-regex-literals */
/* eslint-disable no-control-regex */
import * as d3 from 'd3';
// eslint-disable-next-line import/no-cycle
// import { format } from 'date-fns';

export const defaultColor = '#666666';

export const isValidUrl = (str) => {
  if (str?.includes('http://localhost:3013/api/files/public/')) return true;
  const pattern = new RegExp('^(http(s)?:\\/\\/)?' // protocol
    + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' // domain name
    + '((\\d{1,3}\\.){3}\\d{1,3}))' // OR ip (v4) address
    + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' // port and path
    + '(\\?[;&a-z\\d%_.~+=-]*)?' // query string
    + '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
  return !!pattern.test(str);
};

export const mostFrequentInArray = (arr) => Object.entries(
  arr.reduce((item, v) => {
    const a = { ...item };
    a[v] = (a[v] ?? 0) + 1;
    return a;
  }, {}),
).reduce((a, v) => (v[1] >= a[1] ? v : a), [null, 0])[0];

export function hexIsLight(color) {
  const hex = color.replace('#', '');
  const r = parseInt(hex.substring(0, 0 + 2), 16);
  const g = parseInt(hex.substring(2, 2 + 2), 16);
  const b = parseInt(hex.substring(4, 4 + 2), 16);
  const brightness = ((r * 299) + (g * 587) + (b * 114)) / 1000;
  return brightness > 150;
}

export const formatLabel = (value, props) => {
  if (props && value && props?.payload && props?.payload?.unit === '%') {
    return `${value?.toFixed(2)} ${props.payload.unit}`;
  }
  return `${value}`;
};

export const colorScale = (value, min, max) => {
  const color = d3.scaleSequential(d3.interpolatePlasma)
    .domain([min, max]);
  return color(value);
};

export function getPercantage(value, max) {
  const range = (value * 100) / max;
  if (range > 0) {
    return range;
  }
  return range;
}

export function isValidDate(d) {
  return d instanceof Date && !Number.isNaN(d);
}

export const translateDate = {
  fr: {
    week: 'semaine',
    semester: 'semestre',
  },
  en: {
    week: 'week',
    semester: 'semester',
  },
};

/**
 * @param {*} indicatorData
 * @param {*} fields An array of field objects (as returned by craft.controller.ts:getRequestFields)
 * @returns
 */
export const formatIndicatorData = (indicatorData, fields) => {
  const visualisation = [];
  const { aggregations } = indicatorData;
  let data = indicatorData?.entities || indicatorData?.elements || indicatorData.stats;
  const keys = []; // simplified descriptions of fields
  const options = [];
  // try to find a field whose value is 'all' - 'value' means field ID/code
  const foundAll = fields?.find((f) => f.value === 'all');
  foundAll?.options.forEach((opt) => {
    options.push({ ...opt, key: foundAll.value });
    opt.graphs.forEach((g) => {
      visualisation.push(g);
    });
  });
  // IF a field with code 'all' was found, fill the 'keys' array
  if (foundAll) {
    keys.push({
      value: foundAll.value, // the id/code of the field
      label: foundAll.label, // human readable name of the field
      graphs: foundAll.graphs, // types of visual representation for this indicator
      type: foundAll.type, // aka craft's FieldType value
      group: foundAll.group, // aka craft's craft:information field property
      parent: foundAll?.parent, // I'm guessing this would be the parent field?
    });
    // console.debug('Found an "all" field, here is keys', keys);
    // console.debug('And foundAll too', foundAll);
  }

  // type date values into proper Date objects
  data = data.map((d) => {
    const objValue = { ...d };
    Object.entries(objValue).forEach(([key]) => {
      const isDate = fields.find((f) => f.value === key && f.type === 'Date');
      if (isDate) {
        const date = new Date(objValue[key]);
        if (date && isValidDate(date)) { objValue[key] = date; }
      }
    });
    return objValue;
  });

  // console.debug('Raw fields', fields);
  fields.forEach((crtFieldObj) => {
    const alreadyAddedMatchingKey = keys.find((f) => f.value === crtFieldObj.value);
    const foundField = { ...crtFieldObj };
    if (!alreadyAddedMatchingKey) { // if field DOES NOT already exist in keys
      // add the field's code to 'options' & its graphs to 'visualisation'
      foundField.options.forEach((opt) => {
        options.push({ ...opt, key: foundField.value });
        opt.graphs.forEach((g) => {
          if (!visualisation.find((v) => v === g)) {
            visualisation.push(g);
          }
        });
      });
      // format the field's info & add it to the keys
      keys.push({
        value: foundField.value,
        label: foundField.label,
        graphs: foundField.graphs,
        type: foundField.type,
        group: foundField.group,
        parent: foundField?.parent,
        associatedDomainId: foundField.associatedDomainId,
        associatedId: foundField.associatedId,
      });
    } else {
      // console.debug('FoundField', foundField);
      // console.debug('FoundKey', foundKey);
    }
    // Field can also be added as-is to 'keys' if it's part of the Aggregation group
    // why doesn't it need to be formatted then?
    if (crtFieldObj.group === 'Aggregation') {
      keys.push(foundField);
      // console.debug('Found an aggregation field, add it as-is', foundField);
    }
  });

  data = [...data];
  return {
    data,
    aggregations,
    visualisation,
    keys,
    options,
    entitiesData: indicatorData?.entitiesData,
    elementsLabels: indicatorData?.elementsLabels,
  };
};

export const parseHeader = (string) => {
  if (!string.includes('{')) return {};
  const json = JSON.parse(string);
  const validateHeader = new Headers(json);
  let count = 0;
  validateHeader.forEach(() => count++);
  if (count > 0) return json;
  return {};
};
